import {observer} from 'mobx-react';
import React from 'react';
import {X9Content, X9ContentSnapshot} from '../../../../../domain';
import {InputAutoWidth} from '../../../../../lib/components';
import {ReactNodeGenerator} from '../../../../../lib/helpers';
import {X9ContentStateStore} from '../../common/X9ContentStateStore';
import {
  InlineOpenEndedQuestionModel,
  InputItem,
  OpenEndedQuestionParagraph,
  positionToItemId,
  TextItem
} from '../models';
import {OpenEndedQuestionStore} from './OpenEndedQuestionStore';

interface Props {
  x9: X9Content | X9ContentSnapshot
  store: X9ContentStateStore
}

function renderTextItem(item: TextItem, key: number) {
  return <span className="text-item" key={key}>{item.content}</span>;
}

function renderInputItem(store: OpenEndedQuestionStore,
                         paragraphIndex: number,
                         itemIndex: number,
                         item: InputItem) {
  const itemId = positionToItemId(paragraphIndex, itemIndex);
  const state = store.openEndedQuestionState.states[itemId];

  const value = state.value === null ? '' : state.value
  
  return (
    <InputAutoWidth key={itemIndex}
                    font="normal 400 14px Roboto"
                    className="input-item"
                    onChange={(event) => store.changeHandler(itemId, event)}
                    value={value}/>);
}

function* renderParagraphItems(store: OpenEndedQuestionStore,
                               paragraphIndex: number,
                               paragraph: OpenEndedQuestionParagraph): ReactNodeGenerator {
  for (let i = 0; i < paragraph.items.length; i++) {
    let item = paragraph.items[i];
    if (item.type === 'text')
      yield renderTextItem(item, i);
    if (item.type === 'input')
      yield renderInputItem(store, paragraphIndex, i, item);
  }
}

function* renderParagraphs(store: OpenEndedQuestionStore): ReactNodeGenerator {
  const paragraphs = store.model.paragraphs;

  for (let i = 0; i < paragraphs.length; i++) {
    yield (
      <div className="paragraph" key={i}>
        {Array.from(renderParagraphItems(store, i, paragraphs[i]))}
      </div>);
  }
}

@observer
export class StudentOpenEndedQuestionInline extends React.Component<Props> {
  readonly store: OpenEndedQuestionStore;

  constructor(props: Readonly<Props>) {
    super(props);
    const model = JSON.parse(this.props.x9.Contents) as InlineOpenEndedQuestionModel;
    this.store = new OpenEndedQuestionStore(this.props.x9.Id,
      model, this.props.store);
  }

  render() {
    return (
      <div className="row">
        <div className="col">
          <div className="open-ended-question-inline student">
            {Array.from(renderParagraphs(this.store))}
          </div>
        </div>
      </div>);
  }
}
